export default "__VITE_ASSET__CXKz32dj__"